export interface FormSubmitResult {
  ok: boolean;
  message: string;
}

export async function submitReaddyForm(
  form: HTMLFormElement,
  endpoint: string,
  honeypotName: string,
  successMessage: string,
): Promise<FormSubmitResult> {
  const data = new FormData(form);
  const honey = String(data.get(honeypotName) ?? '').trim();

  // 蜜罐命中：不发送任何请求，返回与正常提交一致的反馈
  if (honey) {
    return { ok: true, message: successMessage };
  }
  data.delete(honeypotName);

  const payload = new URLSearchParams();
  data.forEach((value, key) => {
    if (typeof value === 'string' && value.trim() !== '') {
      payload.append(key, value);
    }
  });

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: payload.toString(),
    });

    const responseText = await response.text();
    let parsed: {
      code?: string;
      message?: string;
      meta?: { message?: string; detail?: string };
    } | null = null;
    try {
      parsed = JSON.parse(responseText);
    } catch {
      parsed = null;
    }

    const serverMsg = String(
      parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '',
    );
    const code = parsed?.code ?? '';
    const isSpam = serverMsg.toLowerCase().includes('spam');

    if (response.ok && code === 'OK' && !isSpam) {
      return { ok: true, message: successMessage };
    }

    return {
      ok: false,
      message: isSpam
        ? '提交被拦截，请检查填写内容后重试。'
        : serverMsg || '提交失败，请稍后重试。',
    };
  } catch {
    return { ok: false, message: '网络异常，提交失败，请稍后重试。' };
  }
}